import entitlements from "./entitlements";

import {
  ApartmentOutlined,
  AppstoreOutlined,
  AuditOutlined,
  BankOutlined,
  BarChartOutlined,
  CalendarOutlined,
  ClusterOutlined,
  CommentOutlined,
  DeleteOutlined,
  DollarOutlined,
  DownloadOutlined,
  FolderOpenOutlined,
  ExportOutlined,
  FileOutlined,
  FileTextOutlined,
  FundOutlined,
  KeyOutlined,
  LaptopOutlined,
  LineChartOutlined,
  NodeIndexOutlined,
  NotificationOutlined,
  PhoneOutlined,
  PieChartOutlined,
  ProjectOutlined,
  SafetyCertificateOutlined,
  SettingOutlined,
  SolutionOutlined,
  TagOutlined,
  TagsOutlined,
  TransactionOutlined,
  UngroupOutlined,
  UnorderedListOutlined,
  UploadOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";

const MenuList = [
  {
    name: "Dashboard",
    route: "/",
    icon: LaptopOutlined,
    key: "/",
    entitlement: entitlements.Dashboard.view,
  },
  {
    name: "Admin",
    route: "/admin",
    icon: SettingOutlined,
    key: "/admin",
    entitlement: entitlements.Dashboard.view,
    subMenus: [
      {
        route: "/departments",
        name: "Departments",
        icon: ApartmentOutlined,
      },
      {
        route: "/roles",
        name: "Roles",
        icon: SafetyCertificateOutlined,
      },
      {
        route: "/teams",
        name: "Teams",
        icon: ClusterOutlined,
      },
      {
        route: "/users",
        name: "Users",
        icon: UserSwitchOutlined,
      },
      {
        route: "/sales-people",
        name: "Sales People",
        icon: UserSwitchOutlined,
      },
      {
        route: "/trustees",
        name: "Trustees",
        icon: SolutionOutlined,
      },
      {
        route: "/entitlements",
        name: "Entitlements",
        icon: KeyOutlined,
      },
      {
        route: "/exclusion-lists",
        name: "Exclusion Lists",
        icon: KeyOutlined,
      },
      {
        route: "/providers",
        name: "Provider Management",
        icon: AppstoreOutlined,
      },
      {
        route: "/holidays",
        name: "Holidays",
        icon: CalendarOutlined,
      },
      {
        name: "Product Management",
        route: "/product-management",
        icon: AppstoreOutlined,
        key: "/product-management",
        entitlement: entitlements.Dashboard.view,
        subMenus: [
          {
            route: "/products",
            name: "Products",
            icon: TagsOutlined,
          },
          {
            route: "/product-categories",
            name: "Product Categories",
            icon: TagOutlined,
          },
          {
            route: "/product-statements",
            name: "Product Statements",
            icon: FileTextOutlined,
            entitlement: entitlements.ProductStatements.view,
          },
        ],
      },
      {
        name: "Request Type Management",
        route: "/request-type-management",
        icon: ProjectOutlined,
        key: "/request-type-management",
        entitlement: entitlements.Dashboard.view,
        subMenus: [
          {
            route: "/categories",
            name: "Categories",
            icon: TagsOutlined,
          },
          {
            route: "/subCategories",
            name: "Subcategories",
            icon: TagOutlined,
          },
        ],
      },
      {
        name: "Economic Indicators",
        route: "/economic-indicator",
        icon: BarChartOutlined,
        key: "/economic-indicators",
        entitlement: entitlements.EconomicIndicators.view,
        subMenus: [
          {
            route: "/asset-allocation-items",
            name: "Asset Allocation Items",
            icon: PieChartOutlined,
          },
          {
            route: "/asset-allocation-rates",
            name: "Asset Allocation Rates",
            icon: DollarOutlined,
          },
          {
            route: "/quarters",
            name: "Financial Quarters",
            icon: CalendarOutlined,
          },
          {
            route: "/economic-indicators",
            name: "Inflation & Tbill",
            icon: FundOutlined,
          },
        ],
      },
    ],
  },
  {
    name: "Templates",
    route: "/templates",
    icon: FileOutlined,
    key: "/templates",
    entitlement: entitlements.Dashboard.view,
    subMenus: [
      {
        route: "/communication-templates",
        name: "Communication Templates",
        icon: FundOutlined,
      },
      {
        route: "/downloadable-templates",
        name: "Downloadable Templates",
        icon: DownloadOutlined,
      },
      {
        route: "/template-categories",
        name: "Template Categories",
        icon: FolderOpenOutlined,
      },
    ],
  },

  {
    name: "Business Development",
    route: "/business-development",
    icon: LineChartOutlined,
    key: "/business-development",
    entitlement: entitlements.BusinessDevelopment.list,
  },

  {
    name: "Manage Customers",
    route: "/customers",
    icon: SolutionOutlined,
    key: "/customers",
    entitlement: entitlements.Customers.list,
  },

  {
    name: "Manage Companies",
    route: "/companies",
    icon: ClusterOutlined,
    key: "/companies",
    entitlement: entitlements.Companies.list,
  },

  {
    name: "Requests",
    route: "/requests",
    icon: NodeIndexOutlined,
    key: "/requests",
    subMenus: [
      {
        route: "/loan-requests",
        name: "Loan Requests",
        icon: NodeIndexOutlined,
        entitlement: entitlements.LoanRequests.list,
      },
      {
        name: "Fixed Income",
        route: "/fixed-income",
        icon: NodeIndexOutlined,
        key: "/fixed-income",
        entitlement: entitlements.FixedIncomeRequests.list,
        subMenus: [
          {
            route: "/fixed-income-requests",
            name: "Requests",
            icon: FileTextOutlined,
          },
          {
            route: "/fixed-income-redemptions",
            name: "Redemptions",
            icon: DollarOutlined,
          },
          {
            route: "/fixed-income-payment-instructions",
            name: "Payment Instructions",
            icon: BankOutlined,
          },
        ],
      },
      {
        route: "/transfer-requests",
        name: "Transfer Requests",
        icon: NodeIndexOutlined,
        entitlement: entitlements.TransferRequests.list,
      },
      {
        route: "/redemption-requests",
        name: "Redemption Requests",
        icon: NodeIndexOutlined,
        entitlement: entitlements.RedemptionRequests.list,
      },
      // {
      //   route: "/change-requests",
      //   name: "Change Requests",
      //   icon: NodeIndexOutlined,
      // },
      {
        route: "/online-transactions",
        name: "Online Transactions",
        icon: TransactionOutlined,
        entitlement: entitlements.OnlineTransactions.list,
      },
    ],
  },

  {
    name: "Reporting",
    route: "/reporting",
    icon: UngroupOutlined,
    key: "/reporting",
    entitlement: entitlements.Dashboard.view,
    subMenus: [
      {
        route: "/reports",
        name: "Reports",
        icon: UngroupOutlined,
      },
      {
        route: "/audits",
        name: "Audit Logs",
        icon: AuditOutlined,
      },
      {
        route: "/interactions",
        name: "Interactions",
        icon: CommentOutlined,
      },
      {
        route: "/pre-op-interactions",
        name: "Pre Opportunity Interactions",
        icon: CommentOutlined,
      },
      {
        route: "/notification-records",
        name: "Notification Records",
        icon: NotificationOutlined,
      },
      {
        route: "/company-activities",
        name: "Company Activities",
        icon: UnorderedListOutlined,
      },
      {
        name: "Bulk Uploads",
        route: "/bulk-uploads",
        icon: UploadOutlined,
      },
      {
        name: "USSD",
        route: "/ussd",
        icon: PhoneOutlined,
      },
      {
        name: "QPR Reports",
        route: "/qpr-reports",
        icon: UngroupOutlined,
      },
    ],
  },
  {
    name: "Exported Data",
    route: "/exported-data",
    icon: ExportOutlined,
    key: "/exported-data",
    entitlement: entitlements.Users.view,
  },
  {
    name: "Archives",
    route: "/archives",
    icon: DeleteOutlined,
    key: "/archives",
    subMenus: [
      {
        route: "/archived-customers",
        name: "Archived Customers",
        icon: DeleteOutlined,
        entitlement: entitlements.Customers.list,
      },
      {
        route: "/archived-companies",
        name: "Archived Companies",
        icon: DeleteOutlined,
        entitlement: entitlements.Companies.list,
      },
    ],
  },
];

export default MenuList;
